import { Alert, borderRadius } from '@toggle/design-system';
import styled from 'styled-components';

import { Description } from '~/components/chat-landing/ChatLanding.styles';

import { INVENTORY_WIDTH } from './InventorySidebar/InventorySidebar.styles';

const THINKING_WIDTH = '600px';

export const MainContent = styled.main<{
  $isThinkingSidebarOpen: boolean;
  $isInventoryOpen?: boolean;
}>`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  width: ${({ $isInventoryOpen }) =>
    $isInventoryOpen ? `calc(100% - ${INVENTORY_WIDTH})` : '100%'};
  margin-right: ${({ $isThinkingSidebarOpen, $isInventoryOpen }) => {
    if ($isThinkingSidebarOpen && $isInventoryOpen) {
      return `calc(${INVENTORY_WIDTH} + ${THINKING_WIDTH})`;
    }

    if ($isThinkingSidebarOpen) {
      return THINKING_WIDTH;
    }

    if ($isInventoryOpen) {
      return INVENTORY_WIDTH;
    }

    return '0';
  }};
  --inventory-right-offset: ${({ $isInventoryOpen }) =>
    $isInventoryOpen ? INVENTORY_WIDTH : '0'};
  --chat-message-width: ${({ $isThinkingSidebarOpen, $isInventoryOpen }) =>
    $isThinkingSidebarOpen && $isInventoryOpen ? '640px' : '740px'};
`;

export const ChatWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  transition: bottom 0.3s ease-in-out;
  width: 100%;

  ${Description} {
    text-align: center;
  }
`;

export const ChatInputComposerWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 20px 16px 20px;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const StyledAlert = styled(Alert)`
  ${borderRadius.r2};
`;

export const Content = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const BannerContainer = styled.div`
  margin-bottom: 40px;
`;
